function IconoTikTok({ className = 'size-5' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M16.5 2h-3v13.2a2.8 2.8 0 1 1-2.4-2.77v-3.05a5.85 5.85 0 1 0 5.4 5.83V9.1a7.6 7.6 0 0 0 4.5 1.46V7.55a4.6 4.6 0 0 1-4.5-4.6z" />
    </svg>
  )
}

export default IconoTikTok
